import { ActionButtonModel } from '../../../models/core/action-button.model';
import { RelatedItemModel } from '../../../models/core/related-item.model';
import { HttpMethodEnum } from '../../../models/enums/http-method.enum';
import { OptionalType } from '../../../models/types/optional.type';
import { ControllerService } from '../../../services/controller.service';
import { Tools } from '../tools';

export class ButtonMapper {
    static readonly generic = new ActionButtonModel({ icon: 'send' });
    static readonly create = new ActionButtonModel({ color: 'primary', icon: 'add' });
    static readonly update = new ActionButtonModel({ icon: 'edit' });
    static readonly delete = new ActionButtonModel({ color: 'warn', icon: 'delete' });
    static readonly save = new ActionButtonModel({ color: 'primary', icon: 'save', caption: 'General.Submit' });
    static readonly cancel = new ActionButtonModel({ icon: 'close', caption: 'General.Cancel' });
    static readonly exportCsv = new ActionButtonModel({
        icon: 'list_alt',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel, data?: any) => {
            const blob = new Blob(['\ufeff', data], { type: 'text/csv;charset=utf-8' });
            Tools.Utils.saveFile(blob, `${Date.now()}.csv`);
        }
    });
    static readonly addFavorite = new ActionButtonModel({
        icon: 'favorite',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel) => {
            btn.color = 'warn';
            item.httpMethod = HttpMethodEnum.Delete;
            btn.responseAction = ButtonMapper.removeFavorite.responseAction;
        }
    });
    static readonly removeFavorite = new ActionButtonModel({
        color: 'warn',
        icon: 'favorite',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel) => {
            btn.color = '';
            item.httpMethod = HttpMethodEnum.Post;
            btn.responseAction = ButtonMapper.addFavorite.responseAction;
        }
    });
    static readonly changeHistory = new ActionButtonModel({ icon: 'history' });
    static readonly createUpdateNetvote = new ActionButtonModel({ icon: 'link' });
    static readonly deleteUpdateNetvote = new ActionButtonModel({ icon: 'link_off' });
    static readonly rebuildIndexes = new ActionButtonModel({ icon: 'sort' });
    static readonly approveTransaction = new ActionButtonModel({
        color: 'primary',
        icon: 'check',
        responseAction: () => {
            location.reload();
        }
    });
    static readonly createSchedule = new ActionButtonModel({
        icon: 'event_repeat',
        dialogClosedAction: (btn: ActionButtonModel, parameters: any) => {
            if (parameters.reloadPage === true) {
                location.reload();
            }
        }
    });
    static readonly modifySchedule = new ActionButtonModel({
        color: 'primary',
        icon: 'edit_calendar',
        dialogClosedAction: (btn: ActionButtonModel, parameters: any) => {
            if (parameters.reloadPage === true) {
                location.reload();
            }
        }
    });
    static readonly registerSelf = new ActionButtonModel({
        icon: 'person',
        color: 'primary',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel, data: OptionalType<any>, controllerService: ControllerService) => {
            controllerService.refreshView();
        }
    });
    static readonly checkIn = new ActionButtonModel({
        icon: 'login',
        color: 'primary',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel, data: OptionalType<any>, controllerService: ControllerService) => {
            controllerService.refreshView();
        }
    });
    static readonly checkOut = new ActionButtonModel({
        icon: 'logout',
        color: 'warn',
        responseAction: (btn: ActionButtonModel, item: RelatedItemModel, data: OptionalType<any>, controllerService: ControllerService) => {
            controllerService.refreshView();
        }
    });
}
